import type { ICer } from "@bbj-types/candidate/cer";
import InfoIcon from "@mui/icons-material/Info";
import { type ChipProps, Stack, Typography } from "@mui/material";

export const chipProps: Record<
  ICer["status"],
  { label: ChipProps["label"]; variant: ChipProps["variant"]; color: ChipProps["color"] }
> = {
  draft: {
    label: "Brouillon enregistré",
    variant: "outlined",
    color: "primary",
  },
  toSign: {
    label: "Attente signatures",
    variant: "outlined",
    color: "primary",
  },
  toSignManager: {
    label: "Attente signature responsable",
    variant: "outlined",
    color: "primary",
  },
  toSignCandidate: {
    label: "Attente signature bénéficiaire",
    variant: "outlined",
    color: "primary",
  },
  toSignPaper: {
    label: (
      <Stack
        direction="row"
        sx={{
          gap: 1,
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <Typography variant="body2Underlined">Attente signature papier</Typography>
        <InfoIcon color="primary" fontSize="small" />
      </Stack>
    ),
    variant: "outlined",
    color: "primary",
  },
  signed: {
    label: "Signé",
    variant: "outlined",
    color: "success",
  },
  signedPaper: {
    label: "Signé à la main",
    variant: "outlined",
    color: "success",
  },
  toValidateManager: {
    label: "Attente signature responsable",
    variant: "outlined",
    color: "primary",
  },
  refusedManager: {
    label: "Refus signature responsable",
    variant: "outlined",
    color: "error",
  },
};
